import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getIdToken } from "../../auth";
import {
  IDocuments,
  IPaging,
  IDownloading,
  IDeleted,
  IUpload,
} from "../../types/Document";
import { IDocumentById, IHistory } from "../../types/Documentsid";
import chalk from "chalk";
import logSymbols from "log-symbols";
import { BASE_URL_ENDPOINT } from "../../config/env";
import {
  isHttpCodeSuccess,
  findHttpStatusInfo,
} from "../../../src/Helpers/Http.commons";

interface IState {
  paging: null | IPaging;
  result: IDocuments[];
  search: IDocuments[];
  active: IDownloading | null;
  delete: string;
  upload: IUpload | null;
  history: IHistory[];
  error: null | any;
  statusCode: number | null | undefined;
  response: Object | undefined;
}

const initialState: IState = {
  paging: null,
  result: [],
  search: [],
  active: null,
  delete: "",
  upload: null,
  history: [],
  error: null,
  statusCode: null,
  response: {}
};

interface ISearchAdvanceDocumentsParams {
  key1: string;
  value1: string;
}

interface ISearchMetadataParams {
  option: string;
  value: string;
}

export const getDocuments = createAsyncThunk(
  "documents/get",

  async (params: { Page: number; Take: number }) => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const { Page, Take } = params;
      const url = `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document?repositoryName=${repositoryName}&page=${Page}&take=${Take}`;
      const data = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "repository-name": `${repositoryName}`,
          Authorization: `Bearer ${token}`,
        },
      });
      return await data.json();
    } catch (error) {
      // console.error((logSymbols.error) + chalk.red('Error en el getDocuments***:', error));
      throw error;
    }
  }
);

export const getDocumentsPage = createAsyncThunk(
  "documents/get",

  async (params: { Page: number; Take: number; FileName: string; Filters: Array<object>}) => {
    try {
	    const search = new URLSearchParams(
        params.Filters.map((param: any) => [param.option, param.value])
      ).toString();
      const repositoryName = sessionStorage.getItem("repositoryName");
      let basePath = `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document?repositoryName=${repositoryName}&page=${params.Page}&take=${params.Take}`;
      let url = (basePath += "&" + search);
      if (params.FileName){
        url = url += "&name=" + params.FileName;
      }
	    console.log("getDocumentsPage url", url);
      const token = getIdToken();
      const data = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      });
      return await data.json();
    } catch (error) {
      throw error;
    }
  }
);

export const searchDocuments = createAsyncThunk(
  "documentes/search",
  async (fileName: string): Promise<any> => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const data = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document?page=1&take=10&repositoryName=${repositoryName}&name=${fileName}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return await data.json();
    } catch (error) {
      throw error;
    }
  }
);

export const searchAdvanceDocuments = createAsyncThunk(
  "documents/searchAdvance",
  async (params: Array<object>) => {
    try {
      const search = new URLSearchParams(
        params.map((param: any) => [param.option, param.value])
      ).toString();
      const repositoryName = sessionStorage.getItem("repositoryName");
      let basePath = `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document?page=1&take=10&repositoryName=${repositoryName}`;
      
      let url = (basePath += "&" + search);

      console.log("searchAdvanceDocuments url", url);
      const token = getIdToken();
      const data = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "repository-name": `${repositoryName}`,
          Authorization: `Bearer ${token}`,
        },
      });
      return await data.json();
    } catch (error) {
      throw error;
    }
  }
);

export const downloadDocument = createAsyncThunk(
  "documents/download",
  async (documentId: string) => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const data = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document/${documentId}/download`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.info((logSymbols.success) + chalk.green('Result en el downloadDocument**:', data));
      return await data.json();
    } catch (error) {
      // console.error((logSymbols.error) + chalk.red('Error en downloadDocument***:', error));
      throw error;
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "document/delete",
  async (id: string) => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document/${id}`,        
        {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          return data && data.trim() ? data.trim() : {};
        })
        .catch((error) => {
          console.log("error:", error);
          return error;
        });
      if (response.status === 401) {
        const errorObj = {
          title:
            "El usuario no tiene suficientes permisos para ejecutar esta acción",
          status: response.status,
          detail:
            "El usuario no tiene suficientes permisos para ejecutar esta acción",
        };
        throw new Error(JSON.stringify(errorObj));
      }
      if (response.status === 404) {
        const errorObj = {
          title: "No se pudo encontrar el recurso que solicitó",
          status: response.status,
          detail:
            "No se pudo encontrar el recurso que solicitó. Verifique la URL y vuelva a intentarlo.",
        };
        throw new Error(JSON.stringify(errorObj));
      }
      if (response.status === 500) {
        const errorObj = {
          title: "Ocurrió un error al procesar la solicitud",
          status: response.status,
          detail:
            "Hubo un error al procesar su solicitud. Es posible que no tengas suficientes permisos para ejecutar esta acción.",
        };
        throw new Error(JSON.stringify(errorObj));
      }
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        return response;
      }
    } catch (error) {
      throw error;
    }
  }
);

export const filterDocuments = createAsyncThunk(
  "documents/filterById",
  async (id: string) => {
    const token = getIdToken();
    const repositoryName = sessionStorage.getItem("repositoryName");
    const data = await fetch(
      `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document/${id}`,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "repository-name": `${repositoryName}`,
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .catch((error) => {
        console.log("error:", error);
        return error;
      });
    let arreglo = [];
    arreglo.push(data);
    // Convertir a un arreglo si los datos son un objeto
    return arreglo;
  }
);

export const uploadDocument = createAsyncThunk(
  "document/upload",
  async (data: any) => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const requestData = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/document`,        
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (isHttpCodeSuccess(requestData.status)) {
        return {
          statusCode: requestData.status,
          response: requestData,
          error: null,
        };
      } else {
        const httpData: any = findHttpStatusInfo(requestData.status);
        const { message, title } = httpData;

        return {
          statusCode: requestData.status,
          response: title,
          error: message,
        };
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error al procesar la solicitud");
    }
  }
);

const documentsSlice = createSlice({
  name: "documentsSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDocuments.fulfilled, (state, action) => {
      // state.paging = action.payload.paging;
      // sessionStorage.setItem('total-pages', state.paging!.pages.toString());
      state.result = action.payload.result;
      state.error = null;
    });
    builder.addCase(getDocuments.rejected, (state, action) => {
      state.error = action.payload;
      console.warn(
        logSymbols.warning +
          chalk.yellow(
            "***Error en el getDocuments**:",
            JSON.stringify(state.error, null, 2)
          )
      );
    });
    //
    builder.addCase(searchDocuments.fulfilled, (state, action) => {
      state.result = action.payload.result;
      // console.log(
      //   logSymbols.info +
      //     chalk.white(
      //       "**Result en el searchDocuments**:",
      //       JSON.stringify(state.result, null, 2)
      //     )
      // );
      state.error = null;
    });
    builder.addCase(searchDocuments.rejected, (state, action) => {
      state.error = action.payload;
      console.warn(
        logSymbols.warning +
          chalk.yellowBright(
            "**Error en el searchDocuments**:",
            JSON.stringify(state.error, null, 2)
          )
      );
    });
    builder.addCase(downloadDocument.fulfilled, (state, action) => {
      state.active = action.payload;
      console.log(
        logSymbols.info +
          chalk.bgGreenBright(
            "**Result en el downloadDocument**:",
            JSON.stringify(state.active, null, 2)
          )
      );
      state.error = null;
    });
    builder.addCase(downloadDocument.rejected, (state, action) => {
      state.error = action.payload;
      console.warn(
        logSymbols.warning +
          chalk.yellowBright(
            "***Error en el downloadDocument**:",
            JSON.stringify(state.error, null, 2)
          )
      );
    });
    // builder.addCase(
    //   deleteDocument.fulfilled, (state, action) => {
    //     state.delete = action.payload;
    //     console.log((logSymbols.info) + chalk.bgGreenBright('**Result en el deleteDocument**:', JSON.stringify(state.delete, null, 2)));
    //     state.error = null;
    //   }
    // );
    // builder.addCase(
    //  deleteDocument.rejected, (state, action) => {
    //     state.error = action.payload;
    //     console.warn((logSymbols.warning) + chalk.yellowBright('***Error en el deleteDocument**:', JSON.stringify(state.error, null, 2)));
    //   }
    // );

    builder
      .addCase(deleteDocument.pending, (state) => {
        state.delete = "";
        // console.log("result",state.result.status)
        state.error = null;
        // console.log("Error",state.error)
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.delete = action.payload;
        // console.log("result",state.result)
        state.error = null;
        // console.log("Error",state.error)
      })
      .addCase(deleteDocument.rejected, (state, action) => {
        state.delete = "";
        const errorObj = action.error?.message
          ? JSON.parse(action.error.message.replace(/\\/g, ""))
          : {};
        state.error = errorObj;
        const formattedErrorObj = {
          status: errorObj.status,
          detail: errorObj.detail,
        };
      });

    builder
      .addCase(uploadDocument.pending, (state) => {
        state.statusCode = null;
        state.response = {};
        state.error = null;
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        const { statusCode, response, error } = action.payload;

        state.statusCode = statusCode;
        state.response = response;
        state.error = error;
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.statusCode = 500;
        (state.response = "Error en el servidor, testing"),
          (state.error =
            "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.");
      });

    builder
      .addCase(filterDocuments.fulfilled, (state, action) => {
        state.result = action.payload;
        console.log(
          logSymbols.info +
            chalk.bgGreenBright(
              "**Result en el filterDocuments**:",
              JSON.stringify(state.result, null, 2)
            )
        );
        state.error = null;
      })
      .addCase(filterDocuments.rejected, (state, action) => {
        state.error = action.payload;
        console.warn(
          logSymbols.warning +
            chalk.yellowBright(
              "***Error en el filterDocuments**:",
              JSON.stringify(state.error, null, 2)
            )
        );
      });
    builder
      .addCase(searchAdvanceDocuments.fulfilled, (state, action) => {
        state.result = action.payload.result;
        console.log(
          logSymbols.info +
            chalk.bgGreenBright(
              "**searchAdvanceDocuments**:",
              JSON.stringify(state.result, null, 2)
            )
        );
        state.error = null;
      })
      .addCase(searchAdvanceDocuments.rejected, (state, action) => {
        state.error = action.payload;
        console.warn(
          logSymbols.warning +
            chalk.yellowBright(
              "***Error en el searchAdvanceDocuments**:",
              JSON.stringify(state.error, null, 2)
            )
        );
      });
  },
});

export default documentsSlice.reducer;
